import { createStore } from 'vuex'

// Import các modules
import app from './modules/app'
import auth from './modules/auth'
import dashboard from './modules/dashboard'
import shifts from './modules/shifts'
import personnel from './modules/personnel'
import attendance from './modules/attendance'
import attendanceLocations from './modules/attendanceLocations'
import hrmSync from './modules/hrmSync'
import settings from './modules/settings'

// Tạo và cấu hình store
const store = createStore({
  modules: {
    app,
    auth,
    dashboard,
    shifts,
    personnel,
    attendance,
    attendanceLocations,
    hrmSync,
    settings
  },
  
  // Plugin để lưu một số state vào localStorage
  plugins: [
    store => {
      // Lưu token khi thay đổi
      store.subscribe((mutation, state) => {
        if (mutation.type === 'auth/SET_TOKENS') {
          localStorage.setItem('access_token', state.auth.access_token)
          localStorage.setItem('refresh_token', state.auth.refresh_token)
        }
        
        if (mutation.type === 'auth/CLEAR_TOKENS') {
          localStorage.removeItem('access_token')
          localStorage.removeItem('refresh_token')
        }
      })

      // Lưu cài đặt người dùng
      store.subscribe((mutation, state) => {
        if (mutation.type.startsWith('settings/')) {
          localStorage.setItem('user_settings', JSON.stringify(state.settings))
        }
      })
    }
  ],

  // Strict mode trong môi trường development
  strict: process.env.NODE_ENV !== 'production'
})

// Reset store khi logout
store.subscribeAction({
  after: (action) => {
    if (action.type === 'auth/logout') {
      // Reset các module về trạng thái ban đầu
      store.commit('dashboard/RESET')
      store.commit('shifts/RESET')
      store.commit('personnel/RESET')
      store.commit('attendance/RESET')
      store.commit('attendanceLocations/RESET')
      store.commit('hrmSync/RESET')
      store.commit('settings/RESET')
    }
  }
})

export default store